"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfConversationMessageProfileDto = instanceOfConversationMessageProfileDto;
exports.ConversationMessageProfileDtoFromJSON = ConversationMessageProfileDtoFromJSON;
exports.ConversationMessageProfileDtoFromJSONTyped = ConversationMessageProfileDtoFromJSONTyped;
exports.ConversationMessageProfileDtoToJSON = ConversationMessageProfileDtoToJSON;
exports.ConversationMessageProfileDtoToJSONTyped = ConversationMessageProfileDtoToJSONTyped;
/**
 * Check if a given object implements the ConversationMessageProfileDto interface.
 */
function instanceOfConversationMessageProfileDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('firstName' in value) || value['firstName'] === undefined)
        return false;
    if (!('lastName' in value) || value['lastName'] === undefined)
        return false;
    return true;
}
function ConversationMessageProfileDtoFromJSON(json) {
    return ConversationMessageProfileDtoFromJSONTyped(json, false);
}
function ConversationMessageProfileDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
    };
}
function ConversationMessageProfileDtoToJSON(json) {
    return ConversationMessageProfileDtoToJSONTyped(json, false);
}
function ConversationMessageProfileDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
    };
}
//# sourceMappingURL=ConversationMessageProfileDto.js.map